import { PermissionV2 } from '@breezy/shared'
import { useMemo } from 'react'
import { useIsAuthorized } from './useIsAuthorized'

export const useCanViewAllFieldAccounts = () => {
  const isAuthorized = useIsAuthorized()

  return useMemo(() => {
    return isAuthorized(PermissionV2.FIELD_ACCOUNTS_CONTACTS_VIEW_FULL)
  }, [isAuthorized])
}
